import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/sharp-solid-svg-icons/faCircleQuestion';
import classNames from 'classnames';

import styles from '../app-header.module.less';

type HelpIconProps = {
  className?: string;
};

export const HelpIcon = ({ className, ...rest }: HelpIconProps) => (
  <FontAwesomeIcon className={classNames(styles['menu-item-icon'], className)} icon={faCircleQuestion} {...rest} />
);
